import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 22.5H3c-.83 0-1.5-.67-1.5-1.5V3c0-.83.67-1.5 1.5-1.5h6v5.25A2.25 2.25 0 0 0 11.25 9h5.25v12c0 .83-.67 1.5-1.5 1.5m-3.75-15a.75.75 0 0 1-.75-.75V1.523a.7.7 0 0 1 .347.197l5.433 5.433a.74.74 0 0 1 .197.347zM3 0C1.345 0 0 1.345 0 3v18c0 1.655 1.345 3 3 3h12c1.655 0 3-1.345 3-3V7.683a2.25 2.25 0 0 0-.66-1.59L11.91.662A2.25 2.25 0 0 0 10.323 0zm0 3.75c0 .412.337.75.75.75h3c.412 0 .75-.338.75-.75A.75.75 0 0 0 6.75 3h-3a.75.75 0 0 0-.75.75m0 3c0 .412.337.75.75.75h3c.412 0 .75-.338.75-.75A.75.75 0 0 0 6.75 6h-3a.75.75 0 0 0-.75.75m7.5 13.5c0 .413.338.75.75.75h3c.412 0 .75-.337.75-.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75m3-4.5h-9v-3h9zm-9-4.5c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
    }, null, -1)
  ])))
}
export default { render: render }